import BasicRouterView from "../../../components/BasicRouterView.vue";

const ordemRoutes = {
  path: "odm",
  redirect: { name: "perfis-papeis" },
  meta: {
    label: "Ordem de Serviço",
    icon: "border_all",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "ordem/ordem-listar",
      name: "ordem-lisar",
      meta: {
        label: "Funções",
        icon: "list",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/ListarOrdem.vue"),
    },
    {
      path: "ordem/ordem-requisitar/:id",
      name: "ordem-requisitar",
      meta: {
        label: "Funções",
        icon: "list",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/Requisitar.vue"),
    },
  ],
};

export default ordemRoutes;
